import { HTMLAttributes, PropsWithChildren } from 'react';
import './WhiteGreenWrapper.scss';
interface Props {
  rightSideContent?: JSX.Element;
  className?: string;
}

export default function WhiteGreenWrapper({
  children,
  rightSideContent,
  className = '',
  ...rest
}: PropsWithChildren<Props & HTMLAttributes<HTMLDivElement>>) {
  return (
    <div
      className={`WhiteGreenWrapper d-flex flex-column ${className} bg-white `}
      {...rest}
    >
      <div className='container flex-grow-1 d-flex flex-column'>
        <div className='row row-cols-1 flex-grow-1 WhiteGreenWrapper__row'>
          <div className='col col-lg-7 bg-white pt-4 pt-lg-5'>
            <div className='WhiteGreenWrapper__content px-1 px-lg-0'>
              {children}
            </div>
          </div>
          <div className='col col-lg-5 bg-primary pt-4 pt-lg-5 text-white d-flex flex-column WhiteGreenWrapper__right'>
            <div className='flex-grow-1'>{rightSideContent}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
